module.exports = __webpack_public_path__ + "img/walls-top-desktop.e0b10a1c.png";